export default __webpack_public_path__ + "static/media/Nestle.291bb263.svg";